module.exports = __webpack_public_path__ + "static/assets/869b3c7c63935a4b7f5735f2b8c70a19.svg";